<template>
  <div class="admin-page">
    <div class="admin-page-inner">
      <div v-if="groupDetails">
        <div class="modalbg">
          <div class="modalcontent p-5 lg:!w-auto !text-center">
            <button type="button" class="admin-button--ghost admin-button--icon absolute right-5" aria-label="Schließen" @click="groupDetails = null">
              <i ref="xmark" class="fa fa-xmark text-xl"></i>
            </button>
            <input class="inline-block border-b-2 border-black w-96 text-3xl font-bold mt-2 mx-10 text-center" placeholder="Gruppenname" v-model="groupDetails.name">
            <div class="md:grid grid-cols-2 mt-5 text-left">
              <div class="mx-2">
                <h2 class="text-xl font-bold">Gruppenmitglieder</h2>
                <div v-for="member in groupDetails.members" :key="member.id">
                  <span class="cursor-pointer hover:font-bold" @click="groupDetails.members.splice(groupDetails.members.indexOf(member), 1)">{{ member.surname }}, {{ member.name }} ({{ member.persnr }})</span>
                </div>
              </div>
              <div class="mx-2">
                <h2 class=" text-xl font-bold">Alle Nutzer</h2>
                <div class="h-96 overflow-y-auto p-2 rounded-lg">
                  <div v-for="user in allUsers" :key="user.id">
                    <span class="cursor-pointer hover:font-bold" @click="groupDetails.members.push(user)">{{ user.surname }}, {{ user.name }} ({{ user.persnr }})</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <button type="button" class="admin-button--primary mt-2" @click="saveMessageGroup()">Gruppe speichern</button>
            </div>
          </div>
        </div>
      </div>
      <div class="admin-page-header">
        <div>
          <h1 class="admin-page-title">Nachrichtencenter</h1>
        </div>
        <div class="admin-action-bar">
          <button type="button" @click="groupDetails = { name: '', members: [] }" class="admin-button--primary">
            Neue Gruppe
          </button>
        </div>
      </div>
      <div class="text-center">
        <div class="hidden">
          <input ref="fileinput" id="fileinput" type="file" accept=".jpg, .jpeg" @change="prepareUploadFile()" />
        </div>
        <div v-if="allUsers.length > 0" id="tablecontent" class="w-full">
          <table class="max-w-full overflow-x-auto md:table">
            <thead>
              <th>Name</th>
              <th>Mitglieder</th>
              <th>Letzte Nachricht</th>
              <th>Neue Nachricht</th>
              <th class="text-center">Aktionen</th>
            </thead>
            <tbody>
              <tr v-for="group in allGroups" :key="group.id" :class="group.static ? '!bg-green-50' : ''">
                <td>{{ group.name }}</td>
                <td>
                  <span class="block" v-for="member in group.members" :key="member.id">{{ member.surname }}, {{ member.name }} ({{ member.persnr }})</span>
                </td>
                <td><pre>{{ group.lastMessage.message }}</pre></td>
                <td>
                  <div class="w-96">
                    <textarea class="bg-gray-200 w-full p-2" v-model="group.newMessage"></textarea>
                    <div class="flex gap-2 justify-end mt-2">
                      <button type="button" class="admin-button--primary admin-button--sm" @click="sendMessage(group)">Senden (SMS)</button>
                      <button type="button" class="admin-button--secondary admin-button--sm" @click="sendMessageViaApp(group)">Senden (App)</button>
                    </div>
                  </div>
                </td>

                <td class="align-top">
                  <div class="text-center">
                    <button v-if="!group.static" type="button" class="admin-button--secondary admin-button--sm mx-1 mt-4" @click="groupDetails = group">
                      Gruppe ändern
                    </button>
                    <button v-if="!group.static" type="button" class="admin-button--danger admin-button--sm mx-1 mt-4" @click="deleteGroup(group)">
                      Gruppe löschen
                    </button>
                  </div>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CASP from "../../CASP";
import { useCookies } from "vue3-cookies";
export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  name: "Jobs",
  components: {},
  data() {
    return {
      token: "",
      allUsers: [],
      groupDetails: null,
      allGroups: [],
    };
  },
  methods: {
    getUsers() {
      let vm = this;
      CASP.getUsers(this.token, (res) => {
        if (res) {
          vm.allUsers = res
          this.allUsers.sort((a, b) => {
            const surnameA = a.surname.toLowerCase();
            const surnameB = b.surname.toLowerCase();

            if (surnameA < surnameB) {
              return -1;
            }
            if (surnameA > surnameB) {
              return 1;
            }
            return 0;
          });
        }
      });
    },
    getMessageGroups() {
      let vm = this
      CASP.getMessageGroups(this.token, (res) => {
        if (res) {
          vm.allGroups = res;
        }
      })
    },
    deleteGroup(group) {
      let vm = this
      CASP.deleteMessageGroup(this.token, group, (res) => {
        this.getMessageGroups()
      })
    },
    sendMessage(group) {
      let vm = this
      CASP.sendMessageToGroup(this.token, group, { message: group.newMessage },(res) => {
        if(res) {
          this.getMessageGroups()
        }
      })
    },
    sendMessageViaApp(group) {
      let vm = this
      CASP.sendMessageToGroupViaApp(this.token, group, { message: group.newMessage },(res) => {
        if(res) {
          this.getMessageGroups()
        }
      })
    },
    saveMessageGroup() {
      CASP.saveMessageGroup(this.token, this.groupDetails, (res) => {
        if (res) {
          this.groupDetails = null
          this.getMessageGroups()
        }
      })
    }
  },
  created: function () {
    document.getElementById("mainspinner").style.display = "none";
    if (this.cookies.get("caspauth") || this.cookies.get("authtoken")) {
      this.token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
      CASP.isAuthenticated(this.token, (auth) => {
        if (!auth) {
          window.location = "/admin/login";
        } else {
          this.getUsers();
          this.getMessageGroups();
        }
      });
    } else {
      window.location = "/admin/login";
    }
  },
};
</script>
<style scoped></style>